<template>
  <LcSkeleton v-if="loading" width="15rem" height="1.5rem" radius="medium" />

  <div class="bg-secondary-secondary-disabled w-fit p-050 rounded-m" v-else>
    <LcLotteryCutoffTime
      v-if="currentDraw"
      :key="`lotterycutofftime_${locale}_${currentDraw.id}_${currentDraw.closingDate}`"
      :cutoff-time="currentDraw.closingDate"
      single-line
      :time-zone="currentDraw.lotteryConfig.timeZone"
      @cutoff-time-reached="emit('cutoff-time-reached')"
    />
  </div>
</template>

<script lang="ts" setup>
import type { ScheduledDraw } from '../@types/editor'

type Emits = {
  (e: 'cutoff-time-reached'): void
}

type Props = {
  currentDraw: Maybe<ScheduledDraw>
  loading: boolean
}

const emit = defineEmits<Emits>()

defineProps<Props>()

const { locale } = useI18n()
</script>
